import React from 'react'
import { graphql } from 'gatsby'
import styled, { css } from 'styled-components'
import { Parallax } from 'react-scroll-parallax'
import Img from 'gatsby-image'
import {
  Row,
  Col,
  Gap,
  Text,
  Title,
  Section,
  Button,
  TechnologyTop,
  TechnologyTopVideo,
  Link,
  SEO,
} from '../components'
import { up, addResponsivity } from '../lib/styles'

const CockpitWrapper = styled.div`
  position: relative;
  width: 100%;
`
const SkyWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  ${addResponsivity()}
`

const HighlightImageCol = (props) => (
  <Col
    grow="1"
    maxWidth="740px"
    mobileMaxWidth="600px"
    bp="tablet"
    shrink="1"
    basis="50%"
    {...props}
  />
)
const HighlightTextCol = (props) => <Col maxWidth="740px" shrink="1" {...props} />

class Index extends React.Component {
  render() {
    const {
      location: { pathname },
      data: {
        topImage,
        topTabletImage,
        t1,
        t2,
        t3,
        // cockpitImage,
        // skyImage,
        cabinImage1,
        cabinImage2,
      } = {},
    } = this.props

    return (
      <>
        <SEO
          title="Technology | Zuri"
          description="We are developing a modern private aircraft with vertical takeoff and landing. This will allow you to affordably travel from city to city at distances of up to 700 km apart."
          pathname={pathname}
        />
        {/* <TechnologyTop image={topImage} imageTablet={topTabletImage} /> */}
        <Gap.Top />
        <div style={{ width: '100%', background: 'white' }}>
          <TechnologyTopVideo />
          <Section background="white">
            <Gap gap="60px" mobileGap="60px" />
            <Title.Big innerAs="h1">TECHNICAL HIGHLIGHTS</Title.Big>
            <Gap gap="150px" mobileGap="50px" bp="tablet" />
            <Row responsive bp="tablet" alignItems="center" mobileAlignItems="unset">
              <HighlightImageCol maxHeight="422px">
                <Img
                  fluid={t1.image.fluid}
                  imgStyle={{
                    objectFit: 'contain',
                  }}
                />
              </HighlightImageCol>
              <Gap gap="80px" mobileGap="30px" bp="tablet" />
              <HighlightTextCol>
                <Text>
                  <Text.Black>TILTROTORS. </Text.Black>
                Four propulsion units in the front and four in the back tilt between vertical and
                horizontal positions. These electric motors form a distributed electric propulsion
                system which is fully redundant. Even with a failure of any component, safe flight
                is guaranteed.
                </Text>
              </HighlightTextCol>
            </Row>

            <Gap gap="140px" mobileGap="40px" showBelow="desktop" bp="tablet" />
            <Gap gap="80px" showAfter="desktop" />

            <Row responsive bp="tablet" alignItems="center" mobileAlignItems="unset">
              <HighlightImageCol maxHeight="360px">
                {/* <Gap gap="50px" /> */}
                <Img
                  fluid={t2.image.fluid}
                  imgStyle={{
                    objectFit: 'contain',
                  }}
                />
              </HighlightImageCol>
              <Gap gap="80px" mobileGap="40px" bp="tablet" />
              <HighlightTextCol>
                <Text>
                  <Text.Black>GEN SET. </Text.Black>
                Zuri has a turbine coupled with a generator onboard. This system provides electric
                energy throughout the whole flight and allows Zuri to achieve range several times
                greater than any eVTOL.
                </Text>
              </HighlightTextCol>
            </Row>


            <Gap gap="140px" mobileGap="10px" showBelow="desktop" bp="tablet" />
            <Gap gap="40px" showAfter="desktop" />

            <Row responsive bp="tablet" alignItems="center" mobileAlignItems="unset">
              <HighlightImageCol maxHeight="457px">
                <Gap gap="50px" />
                <Img
                  fluid={t3.image.fluid}
                  imgStyle={{
                    objectFit: 'contain',
                  }}
                />
              </HighlightImageCol>
              <Gap gap="80px" mobileGap="40px" bp="tablet" />
              <HighlightTextCol>
                <Text>
                  <Text.Black>BATTERY PACK. </Text.Black>
                The battery packs consist of modern lightweight lithium cells. There are several
                independent battery boxes, which are individually monitored and protected by an
                intelligent battery management system. The boxes are equipped with fireproof
                insulation for maximum safety.
                </Text>
              </HighlightTextCol>
            </Row>
            <Gap gap="180px" />
          </Section>
        </div>
        {/* <CockpitWrapper>
          <SkyWrapper showAfter={1100}>
            <Parallax y={[-20, 20]}>
              <Img fluid={skyImage.image.fluid} />
            </Parallax>
          </SkyWrapper>
          <SkyWrapper hideAfter={1100}>
            <Parallax y={[-20, 0]}>
              <Img fluid={skyImage.image.fluid} />
            </Parallax>
          </SkyWrapper>
          <Img fluid={cockpitImage.image.fluid} />
        </CockpitWrapper> */}

        <Img fluid={cabinImage1.image.fluid} />
        <Gap gap="32px" />

        <Img fluid={cabinImage2.image.fluid} />

        <Section>
          <Gap gap="125px" mobileGap="40px" bp="tablet" />
          <Row justifyContent="space-between" responsive bp="tablet">
            <Col maxWidth="686px">
              <Text>
                <Text.Black>FLIGHT CONTROL & AUTOPILOT. </Text.Black>
                The flight control system consists of a redundant fly-by-wire system with a
                mechanical backup for airplane control surfaces. The sophisticated autopilot
                provides flight control based on multiple inputs, traffic, or terrain information to
                ensure a maximum level of safety.
              </Text>
            </Col>
            <Gap gap="80px" mobileGap="40px" bp="tablet" />
            <Col maxWidth="748px">
              <Text>
                <Text.Black>COMPUTER VISION & SENSORS. </Text.Black>
                Computerized vision and other sensors offer supplemental safety features to help
                pilots with enhanced situation awareness for maximum safety. The system is based on
                sophisticated AI algorithms for object recognition, optical flow, and 3D modeling.
              </Text>
            </Col>
          </Row>
          <Gap gap="125px" mobileGap="40px" bp="tablet" />
          <Row justifyContent="center">
            <Button.Link to={Link.STORY}>OUR STORY</Button.Link>
          </Row>
          <Gap gap="40px" />
        </Section>
      </>
    )
  }
}

export default Index

export const pageQuery = graphql`
  fragment TechnologyImage1 on File {
    image: childImageSharp {
      fluid(maxWidth: 1280, maxHeight: 618, quality: 95) {
        ...GatsbyImageSharpFluid_withWebp
      }
    }
  }
  fragment TechnologyImage2 on File {
    image: childImageSharp {
      fluid(maxWidth: 1100, maxHeight: 820, quality: 95) {
        ...GatsbyImageSharpFluid_withWebp
      }
    }
  }
  fragment TechnologyImage3 on File {
    image: childImageSharp {
      fluid(maxWidth: 558, maxHeight: 407, quality: 95) {
        ...GatsbyImageSharpFluid_withWebp
      }
    }
  }

  fragment TopMobileImage on File {
    image: childImageSharp {
      fluid(maxWidth: 980, quality: 95) {
        ...GatsbyImageSharpFluid_withWebp
      }
    }
  }

  query {
    topImage: file(relativePath: { eq: "images/technology/top.jpg" }) {
      ...FullHdImage
    }
    topTabletImage: file(relativePath: { eq: "images/technology/top-tablet.jpg" }) {
      ...TopMobileImage
    }
    t1: file(relativePath: { eq: "images/technology/tiltrotor_schema.png" }) {
      ...TechnologyImage1
    }
    t2: file(relativePath: { eq: "images/technology/turbogen.png" }) {
      ...TechnologyImage2
    }
    t3: file(relativePath: { eq: "images/technology/BATTERY_PACK.png" }) {
      ...TechnologyImage3
    }
    cabinImage1: file(relativePath: { eq: "images/technology/zuri-cabin-1.jpg" }) {
      ...FullHdImage
    }
    cabinImage2: file(relativePath: { eq: "images/technology/zuri.jpg" }) {
      ...FullHdImage
    }
    # cockpitImage: file(relativePath: { eq: "images/technology/cockpit.png" }) {
    #   ...FullHdImage
    # }
    # skyImage: file(relativePath: { eq: "images/technology/sky.jpg" }) {
    #   ...FullHdImage
    # }
  }
`
